import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    licensing: [],
    order_column: 'id',
    order_type: 'desc',
    page: 1,
    page_size: 10,
    dialog: false,
    filter: {}
  },

  mutations: {
    setLicensing(state, payload) {
      state.licensing = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    },
    setFilter(state, payload) {
      state.filter = payload
    }
  },

  actions: {
    readLicensing({ commit, state }) {
      commit('setLoading', true)

      axios.admin
        .get('cms/youtube/licensing', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            ...state.filter
          }
        })
        .then(r => {
          commit('setLicensing', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    }
  }
}
